import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';

export const MATCHING_STATUS_NO_VARIABLE_SYMBOL = 'no_variable_symbol';
export const MATCHING_STATUS_NEWLY_MATCHED = 'newly_matched';
export const MATCHING_STATUS_PARTIALLY_PAID = 'partially_paid';
export const MATCHING_STATUS_ALREADY_MATCHED = 'already_matched';
export const MATCHING_STATUS_NOT_FOUND = 'not_found';

export const MATCHING_STATUS_CONFIG = {
    [MATCHING_STATUS_NO_VARIABLE_SYMBOL]: {
        text: 'Bez variabilního symbolu',
        color: '#ff9800',
        backgroundColor: '#fff3e0',
        success: false
    },
    [MATCHING_STATUS_NEWLY_MATCHED]: {
        text: 'Nově spárováno',
        color: '#4caf50',
        backgroundColor: '#e8f5e9',
        success: true
    },
    [MATCHING_STATUS_PARTIALLY_PAID]: {
        text: 'Uhrazena nepřesná částka',
        color: '#2196f3',
        backgroundColor: '#e3f2fd',
        success: true
    },
    [MATCHING_STATUS_ALREADY_MATCHED]: {
        text: 'Již bylo spárované',
        color: '#9e9e9e',
        backgroundColor: '#f5f5f5',
        success: false
    },
    [MATCHING_STATUS_NOT_FOUND]: {
        text: 'Nenalezeno',
        color: '#f44336',
        backgroundColor: '#ffebee',
        success: false
    }
};

export interface PaymentMatchingResult {
    invoice: any;
    booking_date: string;
    counterparty: string;
    counterparty_account_number: string;
    variable_symbol: string;
    amount: number;
    matching_result: string;
}

@Component({
    selector: 'document-payments-results-dialog',
    templateUrl: './document-payments-results.dialog.component.html',
    styleUrls: ['./document-payments-results.dialog.component.scss']
})
export class DocumentPaymentsResultsDialogComponent implements OnInit {

    displayedColumns: string[] = [
        'invoice',
        'booking_date',
        'counterparty',
        'counterparty_account_number',
        'variable_symbol',
        'amount',
        'matching_result'
    ];

    results: PaymentMatchingResult[] = [];
    readonly MATCHING_STATUS_CONFIG = MATCHING_STATUS_CONFIG;

    constructor(public dialog: MatDialogRef<DocumentPaymentsResultsDialogComponent>,
                @Inject(MAT_DIALOG_DATA) public data: any) {
        if (data && data.results) {
            this.results = data.results;
        }
    }

    ngOnInit(): void {
    }

    getMatchingStatusConfig(matchingResult: string): any {
        return MATCHING_STATUS_CONFIG[matchingResult] || {
            text: matchingResult || '-',
            color: '#757575',
            backgroundColor: '#f5f5f5'
        };
    }

    openInvoice(invoice: any): void {
        if (invoice && invoice.id) {
            window.open(`/documents/edit/${invoice.id}`, '_blank');
        }
    }
}




// WEBPACK FOOTER //
// /app/src/DocumentsModule/DocumentPaymentsResultsDialogComponent/document-payments-results.dialog.component.ts